import React, {useEffect, useState} from 'react';
import {Link, useNavigate, useParams} from "react-router-dom";
import {Divider} from 'primereact/divider';

// import CourseHeaderComp from "../../test/udemy/components/CourseComponents/CourseHeaderComp/CourseHeaderComp";

import {CourseService} from "../../service/CourseService";
import {ChapterService} from "../../service/ChapterService";
import {Card} from "primereact/card";
import CourseCurriculum from "../../components/courseCurriculum/CourseCurriculum";
import List from "../../components/List";
import GeneralUtils from "../../utils/GeneralUtils";
import {SubscribedCourseService} from "../../service/SubscribedCourseService";
import InstructorInfo from "../Instructor/InstructorInfo";
import CourseBreadcrumb from "../../components/breadcrumb/breadcrumb-5";
import CourseDetailsSidebar from "../../components/common/sidebar/course-details-sidebar";
import {TabPanel, TabView} from "primereact/tabview";
import {onHideLoading, onShowLoading} from "../../components/loading/LoadingProvider";

const defaultCourse = {
    title: '',
    headline: '',
    description: '',
    isPublished: false,
    instructionalLevelObject: null,
    instructionalLevel: '',
    objectives: [],
    prerequisites: [],
    targetAudiences: []
}
const Course = () => {
    let isAuth = localStorage.getItem("isAuthenticated") && !GeneralUtils.isNullOrEmpty(localStorage.getItem("isAuthenticated"));
    const [data, setData] = useState(defaultCourse);
    const [chapter, setChapter] = useState([]);
    const [isSubscribed, setIsSubscribed] = useState(false);

    const subscribedCourseService = new SubscribedCourseService();

    const service = new CourseService();
    const chapterService = new ChapterService();

    const {id} = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // Scroll to top when component mounts
        window.scrollTo(0, 0);

        // service.checkPage();
        service.findById(id).then(response => setData(response));
        chapterService.findByCourseId(id).then(response => setChapter(response));
        if(isAuth && !GeneralUtils.isNullOrEmpty(GeneralUtils.getUserId())) {
            subscribedCourseService.findByCourseId(id).then(response => {
                if (!GeneralUtils.isNullOrEmpty(response) && response.course.id == id && response.uuser.id == GeneralUtils.getUserId()) {
                    setIsSubscribed(true);
                }
            });
        }
    }, []);


    const subscribedCourse = () => {
        // if(GeneralUtils.isNullOrEmpty(GeneralUtils.getUser())){
        //     toast.warn("Kayıt sayfasına yönlendiriliyorsunuz...");
        //     return navigate(`/signup`);
        // }
        if(isAuth && !GeneralUtils.isNullOrEmpty(GeneralUtils.getUserId())) {
            setLoading(true);
            let subscribedCourse = {course: data};
            subscribedCourseService.create(subscribedCourse).then(response => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)
                    && GeneralUtils.isNullOrEmpty(response.error)) {
                    setLoading(false);
                    navigate(`/course/view/${id}`);
                }
            });
        } else{
            onShowLoading(true,'Giriş ekranına yönlendiriliyorsunuz...');

            setTimeout(()=>{
                onHideLoading();
                navigate(`/login`);
            },1500);
        }
    };

    return (
        <>
            <CourseBreadcrumb course={data}/>
            <section className="edu-section-gap course-details-area">
                <div className="container">
                    <div className="row row--30">
                        <div className="col-lg-8">
                            <div className="course-details-content">
            {/*<div className="container">*/}
                {/*<CourseHeaderComp data={data} isSubscribed={isSubscribed} subscribedCourse={subscribedCourse}/>*/}
                {/*<div className="course-page-container">*/}
                {/*    <div className="course-page-content">*/}

                        {/*<ul className="list-none p-0 m-0 flex lg:align-items-center select-none flex-column lg:flex-row cursor-pointer">*/}
                        {/*    <li><Button label="Öğrenecekleriniz" text onClick={()=> window.location = "#objectives"}/></li>*/}
                        {/*    <li><Button label="Kurs içeriği" text onClick={()=> window.location = "#curriculum"}/></li>*/}
                        {/*    <li><Button label="Gereksinimler" text onClick={()=> window.location = "#prerequisites"}/></li>*/}
                        {/*    <li><Button label="Açıklama" text onClick={()=> window.location = "#description"}/></li>*/}
                        {/*    <li><Button label="Kimler için" text onClick={()=> window.location = "#targetAudiences"}/></li>*/}
                        {/*</ul>*/}
                        {/*<Divider/>*/}

                                <TabView >
                                    <TabPanel header="Genel Bakış">
                                        <Card id="objectives" title='Öğrenecekleriniz' className='card noshadow course-overview'>
                                        <List data={data.objectives}/>
                                        </Card>

                                        <Card id="prerequisites" title='Gereksinimler' className='noshadow noborder'>
                                            <List data={data.prerequisites}/>
                                        </Card>
                                        <Divider/>

                                        <Card id="description" title='Açıklama' className='noshadow noborder'>
                                            <div dangerouslySetInnerHTML={{__html: data.description}}/>
                                        </Card>
                                        <Divider/>

                                        <Card id="targetAudiences" title='Bu kurs kimler için uygun:' className='noshadow noborder'>
                                            <List data={data.targetAudiences}/>
                                        </Card>
                                    </TabPanel>
                                    <TabPanel header="Kurs içeriği">
                                        <CourseCurriculum data={chapter} title={data.title}
                                                          numOfPublishedLectures={data.numOfPublishedLectures}
                                                          contentInfo={data.contentInfo}/>
                                    </TabPanel>
                                    <TabPanel header="Eğitmenler">
                                        {data.visibleInstructorList?.map((instructor, index) =>
                                            <Link key={index} to={`/instructorInfo/${instructor.id}`}>
                                                <InstructorInfo data={instructor}/>
                                                <Divider/>
                                            </Link>
                                        )}
                                    </TabPanel>
                                </TabView>




                    {/*</div>*/}
                {/*</div>*/}
            {/*</div>*/}
                            </div>
                            </div>

                            <div className="col-lg-4">
                                <CourseDetailsSidebar course={data} isSubscribed={isSubscribed} subscribedCourse={subscribedCourse}/>
                            </div>
                        </div>
                    </div>
            </section>
        </>
    );
};

export default Course;
